import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { Summary, SummaryAnalyticsEvent } from './models/summary.models';

@Component({
  selector: 'idp-overview-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  @Input() content: Summary = {} as Summary;
  @Output() analyticsEvent = new EventEmitter<SummaryAnalyticsEvent>();

  onLinkClick(action: Link): void {
    this.analyticsEvent.emit({
      action,
      id: this.content.level
        ? this.content.title.replace(/\s+/g, '').toLowerCase()
        : 'milesavailable',
      eventType: 'click'
    });
  }

  redirect(link: string) {
    window.open(link, '_blank');
  }

  getLogoClass(level: string) {
    if (+level > 20 || +level === 0) {
      return {
        background: 'var(--tracker-million-miler-globe) var(--no-repeat)'
      };
    } else {
      return {
        background: `var(--tracker-million-miler-${level}) var(--no-repeat)`,
        'background-size': 'var(--unit-36-px)'
      };
    }
  }
}
